<template>
  <div class="iframe">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div id="iframeCon">
        <iframe id="iframe" scrolling="auto" frameborder="0" :src="$route.query.url" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/view/module/Header.vue'
export default {
  name: 'External',
  components: { Header },
  data() {
    return {
      title: this.$route.query.title || '',
      rightContent: 'isNo'
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$bus.$emit('loading', true)
    const mainH = document.getElementById('main')
    mainH.classList.remove('mainFixed')
    this.$nextTick(() => {
      this.iframeHeight()
    })
  },
  activated() {
    window.scrollTo(0, 0)
    this.$bus.$emit('loading', true)
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    iframeHeight() {
      const iframe = document.getElementById('iframe')
      const iframeCon = document.getElementById('iframeCon')
      const iframeConH = document.documentElement.clientHeight
      const iframeConw = document.documentElement.clientWidth
      iframeCon.setAttribute('style', 'min-height:' + iframeConH + 'px')
      iframe.setAttribute('height', iframeConH + 'px')
      iframe.setAttribute('width:', iframeConw + 'px')
    }
  }
}
</script>
